<template>
    <div>
        <DialogoPreAfi ref="refModDatos" titulo="Editar mi legajo" type="modificacion" />
        <DialogoTerminos ref="dialogoTerminos" :fullscreen="$vuetify.breakpoint.mdAndDown" />
        <DialogoFaltaFoto ref="dialogoFaltaFoto" type="foto" :msg="msg" @irAEditar="desplegarMod" />
        <v-dialog v-model="isActive" transition="dialog-bottom-transition" scrollable fullscreen>
            <v-card class="rounded-0">
                <v-card class="rounded-0" height="50" elevation="0">
                    <v-app-bar dense dark flat color="primary" height="50">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon @click="cerrarDialogo"
                                    @keydown.esc="cerrarDialogo">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Cerrar</span>
                        </v-tooltip>
                        <v-toolbar-title>Menú</v-toolbar-title>
                    </v-app-bar>
                </v-card>
                <v-card-text class="pa-0">
                    <div v-if="items.length == 0">
                        <v-progress-linear indeterminate height="5" color="primary"></v-progress-linear>
                        <div v-for="i in 7" :key="i">
                            <v-skeleton-loader type="list-item-avatar" class="mx-0 my-2"></v-skeleton-loader>
                        </div>
                    </div>
                    <DialogoCredencial ref="dialCred" :titulo="titulo" :tipo="tipo">
                    </DialogoCredencial>
                    <DialogoBlockTramite ref="redDialogoBlock" type="constancia" />
                    <Menu :items="items" @comunicaDrawer="irAfuncion"></Menu>
                </v-card-text>
                <v-card-actions class="d-flex flex-column align-center justify-center">
                    <div class="text-center mb-2 mx-2">
                        <v-btn text @click="abrirDialogoTerminos" color="grey darken-3">
                            <v-icon class=" mr-1">mdi-eye-outline</v-icon>
                            V
                            <div class="font-weight-light text-lowercase ">
                                er términos y condiciones
                            </div>
                        </v-btn>
                    </div>
                    <div class="text-center mb-2">
                        <v-chip x-small label outlined color="grey">
                            v{{ version }}<span v-if="fechaFormateada" class="mx-1">·</span>{{ fechaFormateada }}
                        </v-chip>
                    </div>
                    <v-btn color="black" block dark class="pa-6 rounded-lg elevation-0" @click="closeSesion">
                        <v-icon class="mr-2">mdi-logout</v-icon>
                        <div class="font-weight-medium ">
                            cerrar sesion
                        </div>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Drawer from '@/components/navigations/Drawer.vue'
import DialogoCredencial from '@/components/dialogos/DialogoCredencial'
import DialogoBlockTramite from '@/components/dialogos/DialogoBlockTramite'
import DialogoFaltaFoto from '@/components/dialogos/DialogoFaltaFoto'
import DialogoTerminos from '@/components/dialogos/DialogoTerminos.vue'
import DialogoPreAfi from '@/components/dialogos/DialogoPreAfi.vue'
import Menu from '@/components/navigations/Menu.vue'

export default {
    name: 'DialogoCard',
    components: {
        Drawer,
        DialogoBlockTramite,
        DialogoFaltaFoto,
        DialogoTerminos,
        DialogoCredencial,
        DialogoPreAfi,
        Menu,
    },
    data() {
        return {
            value: 1,
            group: null,
            toggle: false,
            drawer: true,
            loading: false,
            titulo: '',
            tipo: '',
            isActive: false,
            msg: 'Para generar la credencial y/o constancia recordá subir tu foto de legajo',
            version: process.env.VUE_APP_VERSION || 'dev',
            fechaVersion: process.env.VUE_APP_VERSION_FECHA || '',
        }
    },


    computed: {
        ...mapGetters('auth', ['user', 'tienedeuda', 'pedirFoto', 'esModoGestion']),
        ...mapGetters('dataUser', ['fotoCarnet']),
        ...mapGetters('navigations', ['items']),
        // Convierte la fecha ISO del version.json (YYYY-MM-DD) a DD/MM/YYYY.
        fechaFormateada() {
            if (!this.fechaVersion) return ''
            const partes = this.fechaVersion.split('-')
            if (partes.length === 3) return `${partes[2]}/${partes[1]}/${partes[0]}`
            return this.fechaVersion
        },
    },
    methods: {
        ...mapActions('auth', ['cerrarSesion']),
        ...mapActions('notificaciones', ['startLoading']),
        ...mapActions('opcionNivel', ['abrirDialogoOpcionNivel']),
        solicitarNotificacion() {
            Notification.requestPermission().then(permission => {
                if (permission === 'granted') {
                    new Notification('¡Notificaciones activadas!', {
                        body: 'Ahora recibirás notificaciones.'
                    });
                } else {
                    console.warn('Permiso de notificación denegado:', permission);
                }
            });
        },
        cerrarDialogo() {
            if (this.isActive) {
                window.history.pushState(null, '', window.location.href)
            }
            this.isActive = false
        },
        abrirDialogo() {
            window.history.pushState(null, '', window.location.href)
            this.isActive = true
        },
        goWebMail() {
            const url = "https://webmail.cajapsipba.org.ar/"
            window.open(url, '_blank');
        },
        lanzarDialogo() {
            this.$refs.dialCred.abrirDialogo()
        },
        closeSesion() {
            this.startLoading()
            this.cerrarSesion()
            //this.$router.push('/CerrarSesion').catch(() => { })
        },
        irAfuncion(value) {
            if (value.accion === 'dialogoOpcionNivel') {
                this.cerrarDialogo()
                this.abrirDialogoOpcionNivel()
                return
            }
            switch (value.title.split(' ')[0]) {
                case 'Credencial':
                    this.cerrarDialogo()
                    if (this.pedirFoto) {
                        this.$refs.dialogoFaltaFoto.abrirDialogo()
                        return
                    }
                    this.tipo = "credencial"
                    this.titulo = "Credencial de Afiliado"
                    if (!this.fotoCarnet) this.$refs.dialogoFaltaFoto.abrirDialogo()
                    else this.$refs.dialCred.abrirDialogo()
                    break;
                case 'Constancia':
                    this.cerrarDialogo()
                    if (!this.fotoCarnet) {
                        this.$refs.dialogoFaltaFoto.abrirDialogo()
                        return
                    }
                    if (this.user.tienedeuda) {
                        this.$refs.redDialogoBlock.abrirDialogo()
                        return
                    }
                    this.tipo = "constancia"
                    this.titulo = "Constancia para convenios"
                    this.lanzarDialogo()
                    break;
                default:
                    this.tipo = ""
                    this.titulo = ""
                    break;
            }
            this.cerrarDialogo()
        },
        handleClick(value) {
            console.log(value)
            switch (value.title.split(' ')[0]) {
                case "Credencial":
                    this.tipo = "credencial"
                    this.titulo = "Credencial de Afiliado"
                    this.lanzarDialogo()
                    break;
                case "Constancial":
                    this.tipo = "constancia"
                    this.titulo = "Constancia para convenios"
                    this.lanzarDialogo()
                    break;
                default:
                    this.tipo = ""
                    this.titulo = ""
                    break;
            }
            this.cerrarDialogo()
        },
        abrirDialogoTerminos() {
            this.$refs.dialogoTerminos.abrirDialogo()
        },
        desplegarMod() {
            this.$refs.refModDatos.abrirDialogo()
        }

    },
    mounted() {
    },

}

</script>

<style scoped>
</style>